import { render } from "./Mpesa.vue?vue&type=template&id=6d0d01bb"
import script from "./Mpesa.vue?vue&type=script&lang=js"
export * from "./Mpesa.vue?vue&type=script&lang=js"

import exportComponent from "/home/genicho/PhpstormProjects/mjengo-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__